import type { IconData } from '@stacksjs/iconify-core'

export const mapMarkerF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 20.565q-7-9.135-7-13a7 7 0 1 1 14 0q0 3.865-7 13m0-9a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default mapMarkerF
